import { DomainBase } from "./DomainBase";

export class KOTPrinterClass extends DomainBase {
    constructor() {
        super();
        this.name = "";
        this.printer = "";
        this.isActive = false;
    }
}